export default __webpack_public_path__ + "74b4c4f9cf20433d2595c82433d6c402.svg";